export default __webpack_public_path__ + "assets/img/lock.8a06d4ab63a91404e54074d4ccd3be79.svg";